import { PageIcon } from "./PageIcon.tsx";
import { useIntl } from "react-intl";

/** A page's icon and title, with the localised placeholder for untitled pages. */
export function PageLabel(props: { title: string; icon: string | null; className?: string }) {
  const intl = useIntl();
  return (
    <span className={props.className}>
      {props.icon && (
        <span className="page-icon" aria-hidden="true">
          <PageIcon icon={props.icon} />
        </span>
      )}
      <span className={props.title ? undefined : "untitled"}>
        {props.title || intl.formatMessage({ id: "page.untitled" })}
      </span>
    </span>
  );
}
